export const GET_BUILD_ERROR_CODE = 'BuildNotFound';
